import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export default function MeetMonica() {
  return (
    <section
      id="meet-monica"
      data-testid="meet-monica-section"
      className="py-24 md:py-32"
      style={{ background: "var(--bg-tertiary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative">
          <div
            className="rounded-[2rem] overflow-hidden brand-soft-shadow"
            style={{ border: "1px solid var(--border-soft)" }}
            data-testid="monica-image-wrap"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_postpartum-care-8/artifacts/ywf04kts_thumbnail.jpg"
              alt="Monica, postpartum doula"
              className="w-full h-[560px] object-cover object-center"
            />
          </div>
          <div
            className="absolute -bottom-6 -right-4 md:-right-8 px-5 py-4 rounded-2xl brand-soft-shadow"
            style={{ background: "var(--blush)", color: "#FAF9F6" }}
            data-testid="monica-badge"
          >
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest">
              <Sparkles size={14} /> Certified Postpartum Doula
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="section-eyebrow">Meet Monica</span>
          <span className="gold-divider ml-3 mb-2 align-middle" />
          <h2
            className="font-serif-display mt-4 text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            style={{ color: "var(--text-main)" }}
            data-testid="monica-headline"
          >
            Steady hands. <em className="not-italic" style={{ color: "var(--blush)" }}>Soft heart.</em>
          </h2>
          <p
            className="mt-6 leading-relaxed text-base md:text-lg"
            style={{ color: "var(--text-main)" }}
            data-testid="monica-bio"
          >
            Monica is a certified postpartum doula based in Greater Brisbane. With training in newborn
            care, feeding support and perinatal wellbeing, she brings a calm and grounded presence into
            homes — without judgment, without fuss.
          </p>
          <p className="mt-5 leading-relaxed" style={{ color: "var(--text-muted)" }}>
            "Postpartum is a season of becoming — for the parent, for the baby, for the whole family. My
            role is simply to hold the edges so you can soften into it."
          </p>

          <div
            className="grid grid-cols-3 gap-4 mt-10 p-6 rounded-2xl"
            style={{ background: "var(--bg-secondary)" }}
            data-testid="monica-credentials"
          >
            {[
              ["DONA", "Trained"],
              ["Blue Card", "Certified"],
              ["CPR", "Current"],
            ].map(([title, sub]) => (
              <div key={title} className="text-center">
                <div className="font-serif-display text-2xl" style={{ color: "var(--gold)" }}>
                  {title}
                </div>
                <div className="text-[11px] uppercase tracking-widest mt-1" style={{ color: "var(--text-muted)" }}>
                  {sub}
                </div>
              </div>
            ))}
          </div>

          <Button
            data-testid="monica-book-btn"
            onClick={() => document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })}
            className="mt-8 rounded-full h-12 px-8 transition-transform hover:scale-105"
            style={{ background: "var(--blush)", color: "#FAF9F6" }}
          >
            Schedule a chat with Monica
          </Button>
        </div>
      </div>
    </section>
  );
}
